import { Component, OnInit } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import { faSave, faBroom } from "@fortawesome/free-solid-svg-icons";
import { NotifierService } from "angular-notifier";
import { AccountCodeCreationService } from "src/app/services/autopac/account-code-creation.service";

@Component({
  selector: "app-account-code-creation",
  templateUrl: "./account-code-creation.component.html",
  styleUrls: ["./account-code-creation.component.css"],
})
export class AccountCodeCreationComponent implements OnInit {
  faSave = faSave;
  faBroom = faBroom;

  lockUpdate = true;

  form: FormField[] = [
    {
      type: "search",
      id: "accountCode",
      label: "Account Code",
      required: true,
      searchEvent: true,
      isAuto: true,
    },
    {
      type: "search",
      id: "purpose",
      label: "Purpose",
      required: true,
      searchEvent: true,
      isAuto: true,
    },
  ];

  updateFields(event: any): void {
    this.form = event.fields;
    this.lockUpdate = !this.form.every((item) => item.value);
  }

  constructor(
    private AccountCodeCreationService: AccountCodeCreationService,
    private notifier: NotifierService,
  ) {}

  ngOnInit() {}

  fetchDetails(event: any): void {
    if (event.fieldId == "accountCode") {
      const accountCode = this.getField("accountCode").value || "";
      this.AccountCodeCreationService.getAccountPurpose(
        accountCode,
      ).subscribe({
        next: (response) => {
          if (response.statusCode == 200) {
            this.getField("purpose").value = response.body;
          }
        },
        error: (error) => {
          console.error("Error fetching contract details:", error);
        },
        complete: () =>
          (this.lockUpdate = !this.form.every((item) => item.value)),
      });
    } else if (event.fieldId == "purpose") {
      const purpose = this.getField("purpose").value || "";
      this.AccountCodeCreationService.getAccountCode(
        purpose,
      ).subscribe({
        next: (response) => {
          if (response.statusCode == 200) {
            this.getField("accountCode").value = response.body;
          }
        },
        error: (error) => {
          console.error(error);
        },
        complete: () =>
          (this.lockUpdate = !this.form.every((item) => item.value)),
      });
    }
  }

  add() {
    const accountCode = this.getField("accountCode").value;
    const purpose = this.getField("purpose").value;

    this.AccountCodeCreationService.add(
      accountCode,
      purpose,
    ).subscribe({
      next: (response) => {
        this.notifier.notify("success", "Added successfully");
        this.clear();
      },
      error: (error) => {
        console.error(error);
        this.notifier.notify("error", "Error adding data");
      },
    });
  }

  delete() {
    const purpose = this.getField("purpose").value;
    this.AccountCodeCreationService.delete(purpose).subscribe({
      next: (response) => {
        this.notifier.notify("success", "Deleted successfully");
        this.clear();
      },
      error: (error) => {
        console.error(error);
        this.notifier.notify("error", "Error updating data");
      },
    });
  }

  getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }

  getNumber(id: string): number {
    return Number(this.getField(id).value) || 0;
  }

  clear() {
    this.form.forEach((item) => {
      item.value = undefined;
    });
  }
}
